import React, { Component } from 'react';
import styled, { keyframes } from 'styled-components';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { primaryColor, primaryColorDark } from '~theme';
import { setShow as setModalShow } from '~features/modals/ducks';

import closeIcon from '~images/sulje_profiili.svg';

import { toggleDrawer, getOpenStatus } from './ducks';

const ESC = 27;

class Drawer extends Component {
  componentDidUpdate() {
    if (this.props.isOpen[this.props.name]) {
      window.addEventListener('keydown', this.handleKeyDown);
    } else {
      window.removeEventListener('keydown', this.handleKeyDown);
    }
  }

  handleKeyDown = ({ keyCode }) => {
    if (keyCode === ESC) this.props.toggleDrawer(this.props.name);
  };

  render() {
    const { isOpen, children } = this.props;

    const show = isOpen[this.props.name];

    return (
      <div>
        <Menu isVisible={show}>
          <Button onClick={() => this.props.toggleDrawer(this.props.name)}>
            <CloseIcon src={closeIcon} />
          </Button>

          <div>{children}</div>
        </Menu>

        {show && (
          <Backdrop onClick={() => this.props.toggleDrawer(this.props.name)} />
        )}
      </div>
    );
  }
}

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const Button = styled.button`
  position: absolute;
  top: 24px;
  right: 24px;
  background: transparent;
  border: 0;

  &:active {
    outline: none;
  }
  &:focus {
    outline: none;
  }
`;

const CloseIcon = styled.img`
  width: 26px;
  height: 26px;
  transition: all 0.2s ease;
  // opacity: 0.5;

  &:hover {
    transform: scale(1.1);
    // opacity: 1;
  }
`;

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  animation: ${fadeIn} 0.4s;
  z-index: 9;
`;

const Menu = styled.div`
  position: fixed;
  display: flex;
  overflow-y: scroll;
  padding: 50px 24px;
  top: 0;
  bottom: 0;
  right: 0;
  width: 360px;
  transform: translateX(${props => (props.isVisible ? 0 : 360)}px);
  transition: transform 0.4s cubic-bezier(0.2, 0.71, 0.14, 0.91);
  z-index: 100000000; // Required to show on top of Giosg chat
  flex-direction: column;
  background-color: ${primaryColor};

  @media (max-width: 400px) {
    width: 340px;
    transform: translateX(${props => (props.isVisible ? 0 : 340)}px);
  }

  @media (max-width: 768px) {
    padding: 24px;
  }
`;

// Select values from Redux store and pass them as props to component
const mapStateToProps = state => ({
  isOpen: getOpenStatus(state),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      toggleDrawer,
      setModalShow,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Drawer);
